import { SlideContent } from 'apps/web/types/ppt-slide';

import { REGEX } from '@lessonPlanner/regex';

export function extractBulletPoints(content: string): string[] {
  const bulletPoints = [];
  let match;

  while ((match = REGEX.BULLET_PATTERN.exec(content)) !== null) {
    bulletPoints.push(match[1]);
  }

  return bulletPoints;
}

export function extractNumberedPoints(content: string): string[] {
  const numberedPoints = [];
  let match;

  while ((match = REGEX.NUMBERED_PATTERN.exec(content)) !== null) {
    numberedPoints.push({
      content: match[1],
      number: parseInt(match[2], 10),
    });
  }

  // Sort by number to maintain order
  return numberedPoints
    .sort((a, b) => a.number - b.number)
    .map((item) => item.content);
}

export function extractLeadingString(content: string): string {
  const leadingMatch = REGEX.LEADING_STRING.exec(content);
  return leadingMatch ? leadingMatch[1].trim() : '';
}

export function processSlideContent(content: SlideContent | undefined): {
  points: string[];
  isBulleted: boolean;
  leadingString?: string;
} {
  if (!content) return { points: [], isBulleted: false };

  const contentStr = getContentAsString(content);

  const leadingString = extractLeadingString(contentStr);

  // Check for bullet pattern
  const bulletPoints = extractBulletPoints(contentStr);
  if (bulletPoints.length > 0) {
    return { leadingString, points: bulletPoints, isBulleted: true };
  }

  // Check for numbered pattern
  const numberedPoints = extractNumberedPoints(contentStr);
  if (numberedPoints.length > 0) {
    return { leadingString, points: numberedPoints, isBulleted: false };
  }

  // No special formatting, return content as is
  return {
    points: contentStr ? [contentStr] : [],
    isBulleted: false,
  };
}

export function getContentAsString(content: SlideContent | undefined): string {
  if (!content) return '';

  if (typeof content === 'string') {
    return content;
  }

  if (Array.isArray(content)) {
    return content
      .map((item) => ('content' in item ? item.content : ''))
      .join('\n');
  }

  return 'content' in content ? content.content : '';
}
